import { END_USER_URL } from '../../config';
import React, { useRef } from 'react'
import ModelDialog from './ModelDialog'
import { Box, Button, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import i18next from 'i18next';
import { ReactComponent as CopyIcon } from './../../assets/icons/copyLink.svg';
// import { useTheme } from '@emotion/react';

const ModelCopeLink = ({ openDialog, setOpenDialog, slug }) => {
    //  const [openDialog, setOpenDialog] = useState(false);
    const handleClickOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);
    const [copied, setCopiedId] = useState(false);
    let lng = i18next.language
    // const theme = useTheme()
    const linkRef = useRef(null);

    const copyToClipboard = async () => {
        const linkText = linkRef.current?.textContent;
        if (linkText) {
            // نحاول النسخ باستخدام API الحديثة أولاً
            try {
                await navigator.clipboard.writeText(linkText);
                enqueueSnackbar("تم نسخ الرابط بنجاح", { variant: 'success', });
                setCopiedId(true);
            } catch (error) {
                enqueueSnackbar("الهاتف الذي تستعمله لا يدعم نسخ ", { variant: 'error', });
                console.warn("Failed to use clipboard API, falling back to textarea method:", error);
            }
        };
    };
    return (
        <>
            <ModelDialog openDialog={openDialog} handleClickOpenDialog={handleClickOpenDialog} setOpenDialog={setOpenDialog}>
                <DialogContent sx={{ padding: 0, backgroundColor: theme => theme.palette.primary.main }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            backgroundColor: theme => theme.palette.background.date,
                            py: 1,
                            px: 2,
                        }}
                    >
                        <IconButton onClick={handleCloseDialog} sx={{ color: '#000' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <DialogTitle id="responsive-dialog-title" sx={{ color: '#fff', textAlign: 'center', fontFamily: 'URW DIN Arabic', fontWeight: 'medium', fontSize: 24 }}>
                        {lng === 'ar' ? "رابط فاستر لينك" : 'URL Faster Link'}
                    </DialogTitle>

                    <Typography
                        ref={linkRef}
                        variant='caption'
                        sx={{
                            color: '#fff', margin: '8px 0', textAlign: 'center', border: '1px dashed #fff', mx: 'auto', display: 'flex', width: 'fit-content', p: '0 8px',
                            fontFamily: 'URW DIN Arabic', fontWeight: 'regular', fontSize: 18
                        }}
                    >
                        {` ${END_USER_URL}/${slug}`}
                    </Typography>

                    <Box display="flex" gap={2} my={2} sx={{ justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            onClick={copyToClipboard}
                            sx={{
                                backgroundColor: theme => theme.palette.background.date,
                                color: theme => theme.palette.primary.main,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                '&:hover': { backgroundColor: '#eee' },
                                flexDirection: 'row',
                                py: 1,
                                borderRadius: 8,
                                px: 4
                            }}
                        >
                            <CopyIcon sx={{ fontSize: 'large' }} />
                            <Typography sx={{ fontFamily: 'URW DIN Arabic', fontWeight: 'regular', fontSize: 14 }}>
                                {lng === 'ar' ? (copied ? ' تم النسخ ✅' : 'نسخ الرابط') : (copied ? ' copied ✅' : 'copy link')}
                            </Typography>
                        </Button>
                    </Box>
                </DialogContent>
            </ModelDialog>
        </>
    )
}

export default ModelCopeLink